import { Injectable } from '@angular/core';
import {AuthenticationService} from "./authentication.service";
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from "@angular/router";
import {Observable} from "rxjs";

@Injectable()
export class AuthGuardService implements CanActivate{

  public static redirectUrl: string = null;

  constructor(private authService: AuthenticationService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
    return this.authService.isAuthenticated().do((authenticated: boolean) => {
        if (!authenticated) {
          AuthGuardService.redirectUrl = state.url;
          this.router.navigate(['/login']);
        }
      }
    );
  }


}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/authentication/auth-guard.service.ts